import React, { cloneElement, Fragment, useState } from "react";
import {
  AppBar,
  Toolbar,
  useScrollTrigger,
  Box,
  Stack,
  Menu as NavMenu,
  MenuItem,
} from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import { homepage } from "../../common/routes";
import { Link, useNavigate } from "react-router-dom";
import Menu from "../menu/menu";
import Logo from "../logo/logo";
import NavItemContent from "../../common/navContents";
import { LoginButton, NavItem, ProfileItem } from "./navbar.components";
import { useCookies } from "react-cookie";
import ProfileIcon from "../../images/profile-icon.svg";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import LogoutIcon from "@mui/icons-material/Logout";

import "./navbar.css";

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

function Navbar(props) {
  const navigate = useNavigate()
  const [cookies, setCookie, removeCookie] = useCookies();
  const [programsEl, setProgramsEl] = useState(null);
  const programOpen = Boolean(programsEl);
  const [profileEl, setProfileEl] = useState(null);
  const profileOpen = Boolean(profileEl);
  const path = "/";
  const domain = window.location.hostname;

  function clearCookie() {
    setCookie("emailID", undefined, { path, domain });
    setCookie("firstName", undefined, { path, domain });
    setCookie("lastName", undefined, { path, domain });
    setCookie("userID", undefined, { path, domain });
    setCookie("token", undefined, { path, domain });
    removeCookie("emailID");
    removeCookie("firstName");
    removeCookie("lastName");
    removeCookie("userID");
    removeCookie("token");
    // alert.success("logged out");
    window.location.reload(false);
  }

  return (
    <Fragment>
      <ElevationScroll {...props}>
        <AppBar sx={{ background: "#229FA4" }}>
          <OuterWrapper>
            <InnerWrapper>
              <Toolbar>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ width: { xs: "100%", lg: "initial" } }}
                >
                  <Box component={Link} to={homepage}>
                    <Logo />
                  </Box>
                  <Box
                    component="span"
                    sx={{ display: { xs: "inline", lg: "none" } }}
                  >
                    <Menu />
                  </Box>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ width: "100%", display: { xs: "none", lg: "flex" } }}
                >
                  <Box />
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={3.75}
                  >
                    {NavButton(
                      NavItemContent.general[0].url,
                      NavItemContent.general[0].text
                    )}
                    {NavbarMenu(NavItemContent.dropdown.text)}
                    {NavButton(
                      NavItemContent.general[1].url,
                      NavItemContent.general[1].text
                    )}
                  </Stack>
                  <Box>{authButton()}</Box>
                </Stack>
              </Toolbar>
            </InnerWrapper>
          </OuterWrapper>
        </AppBar>
      </ElevationScroll>
      <Toolbar sx={{ height: 80 }} />
    </Fragment>
  );

  function NavButton(to, text) {
    return (
      <NavItem component={Link} to={to}>
        {text}
      </NavItem>
    );
  }

  function NavbarMenu(buttonText) {
    return (
      <Box>
        <NavItem
          id="programs-button"
          aria-controls={programOpen ? "programs-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={programOpen ? "true" : undefined}
          onClick={(e) => setProgramsEl(e.currentTarget)}
        >
          {buttonText}
        </NavItem>
        <NavMenu
          id="programs-menu"
          anchorEl={programsEl}
          open={programOpen}
          onClose={() => setProgramsEl(null)}
          MenuListProps={{
            "aria-labelledby": "programs-button",
          }}
          sx={{
            "& .css-1poimk-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper":
            {
              width: "350px",
              background:
                "linear-gradient(122.9deg, #3CF0F1 8.18%, #03424A 95.38%)",
              boxShadow: "-2px 4px 4px rgb(0 0 0 / 25%)",
            },
          }}
        >
          {NavItemContent.dropdown.content.map((data) => {
            return (
              <MenuItem onClick={() => {
                navigate(data.url)
                setProgramsEl(null);
              }}>
                {data.text}
              </MenuItem>
            );
          })}
        </NavMenu>
      </Box>
    );
  }

  function authButton() {
    if (cookies.token !== "undefined" && cookies.token !== undefined) {
      return (
        <Box>
          <NavItem
            id="profile-button"
            aria-controls={profileOpen ? "profile-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={profileOpen ? "true" : undefined}
            onClick={(e) => setProfileEl(e.currentTarget)}
          >
            {cookies.lastName}
            <KeyboardArrowDownTwoToneIcon />
            <Box
              component="img"
              src={ProfileIcon}
              sx={{ width: "48px", height: "48px" }}
            />
          </NavItem>
          <NavMenu
            id="profile-menu"
            anchorEl={profileEl}
            open={profileOpen}
            onClose={() => setProfileEl(null)}
            MenuListProps={{
              "aria-labelledby": "profile-button",
            }}
            sx={{
              "& .css-1poimk-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper":
              {
                width: "350px",
                background:
                  "linear-gradient(122.9deg, #3CF0F1 8.18%, #03424A 95.38%)",
                boxShadow: "-2px 4px 4px rgb(0 0 0 / 25%)",
              },
            }}
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="flex-start"
              spacing={0}
              sx={{ width: "100%" }}
            >
              {NavItemContent.conditional.map((data) => {
                return (
                  <Stack
                    direction="row"
                    sx={{
                      width: "89%",
                      borderBottom: "0.5px solid #ffffff",
                      p: 2.3,
                    }}
                    onClick={() => {
                      navigate(data.url)
                      setProfileEl(null);
                    }}
                  >
                    <Box component="img" src={data.icon} />
                    <ProfileItem>
                      {data.text}
                    </ProfileItem>
                  </Stack>
                );
              })}
              <ProfileItem sx={{ p: 2.3 }} onClick={clearCookie}>
                <LogoutIcon sx={{ color: "#f80e0e" }} />
                <ProfileItem logoutColor="#f80e0e" sx={{ pl: 2.5 }}>
                  {NavItemContent.logout.text}
                </ProfileItem>
              </ProfileItem>
            </Stack>
          </NavMenu>
        </Box>
      );
    } else {
      return (
        <LoginButton component={Link} to={NavItemContent.login.url}>
          {NavItemContent.login.text}
        </LoginButton>
      );
    }
  }
}

export default Navbar;
